// src/utils/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://influencer-scheme.onrender.com/api",

});

// Add X-Auth-Phone header automatically if phone is in localStorage
api.interceptors.request.use((config) => {
  const phone = localStorage.getItem("phone");

  if (phone) {
    config.headers["X-Auth-Phone"] = phone;
  }

  // Crucial for file uploads (FormData)
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"]; // Let browser set boundary
  }

  return config;
});

// Optional: Global error handling (e.g., unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("phone");
      window.location.href = "/"; // Redirect to login
    }
    return Promise.reject(error);
  }
);

// THIS LINE WAS MISSING — THIS IS THE FIX!
export default api;